<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <loading-overlay :loading="working" />
        <b-row class="align-items-center w-25 pb-2">
          <b-col>
            <b-form-radio
              class="custom-control-warning"
              name="confirmed"
              value="P"
              v-model="confirmed"
            >
              بانتظار الموافقة
            </b-form-radio>
          </b-col>
          <b-col>
            <b-form-radio
              class="custom-control-success"
              name="confirmed"
              value="A"
              v-model="confirmed"
            >
              الموافق عليها
            </b-form-radio>
          </b-col>
        </b-row>
        <data-table
          :fields="fields"
          id="awaiting-approve"
          ep="v2/ministry/campaigns"
          ref="campaignsTable"
          striped
        >
          <template #cell(ageCategories)="{ item, value }">
            {{ value.map((el) => el.name_ar).join(" , ") }}
          </template>
          <template #cell(campaign_amount)="{ value }">
            {{ new Intl.NumberFormat().format(value) }}
          </template>
          <template #cell(action)="row">
            <div class="d-flex align-items-center justify-content-end">
              <b-badge variant="light-warning" v-if="row.item.featured === 1">
                <feather-icon icon="StarIcon" class="mr-25" />
                <span>مميزة</span>
              </b-badge>
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item variant="info" @click="row.toggleDetails()">
                  <feather-icon icon="InfoIcon" />
                  <span class="align-middle ml-25">{{
                    row.detailsShowing ? "تفاصيل أقل" : "التفاصيل"
                  }}</span>
                </b-dropdown-item>
                <template v-if="row.item.confirmed !== 'A'">
                  <b-dropdown-item
                    variant="danger"
                    @click="onApproveClicked(row.item.id, (status = 'R'))"
                  >
                    <feather-icon icon="XCircleIcon" />
                    <span class="align-middle ml-25">رفض</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="success"
                    @click="onApproveClicked(row.item.id, (status = 'A'))"
                  >
                    <feather-icon icon="CheckSquareIcon" />
                    <span class="align-middle ml-25">موافقة</span>
                  </b-dropdown-item>
                </template>
                <b-dropdown-item
                  @click="
                    onFeaturedClicked(row.item.id, row.item.featured === 0)
                  "
                  v-else
                  variant="warning"
                >
                  <feather-icon icon="StarIcon" />
                  <span class="align-middle ml-25">{{
                    row.item.featured === 1
                      ? "تعيين كغير مميزة"
                      : "تعيين كمميزة"
                  }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
          <template #row-details="{ item }">
            <b-card>
              <b-row>
                <b-col cols="3">
                  <img class="w-100" :src="item.image" alt="" />
                </b-col>
                <b-col cols="5">
                  <h5>وصف الحملة :</h5>
                  <p
                    style="text-align: justify"
                    v-html="item.description_ar"
                  ></p>
                  <h5 class="mt-1">المحافظة :</h5>
                  <p>{{ item.governorate.name_ar }}</p>
                  <h5 class="mt-1">الفئات المستهدفة :</h5>
                  <p>
                    {{ item.ageCategories.map((el) => el.name_ar).join(" , ") }}
                  </p>
                  <h5 class="mt-1">المبلغ المطلوب :</h5>
                  <h4 class="text-success">
                    {{ new Intl.NumberFormat().format(item.campaign_amount) }}
                    ل.س
                  </h4>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </data-table>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BBadge,
  BFormRadio,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BCard,
  BTabs,
  BTab,
  BButton,
  BCol,
  BContainer,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DataTable from "@/components/data-table/index.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import LoaderBtn from "@/components/loader-btn.vue";

export default {
  components: {
    BRow,
    BBadge,
    BFormRadio,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BCol,
    BContainer,
    BTabs,
    BTab,
    LoadingOverlay,
    MinistryBreadcrumbs,
    ToastificationContent,
    DataTable,
    FeatherIcon,
    LoaderBtn,
  },
  data() {
    return {
      mainTitle: "حملات التبرع",
      confirmed: "P",
      breadcrumbs: [
        {
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "حملات التبرع",
          active: true,
        },
      ],
      fields: [
        {
          label: "اسم الحملة",
          key: "name_ar",
        },
        {
          label: "اسم الجمعية",
          key: "ngo.name_ar",
        },
        {
          label: "المبلغ المطلوب",
          key: "campaign_amount",
        },
        {
          label: "الفئة المستهدفة",
          key: "ageCategories",
        },
        {
          label: "تاريخ البداية",
          key: "start_date",
        },
        {
          label: "تاريخ النهاية",
          key: "end_date",
        },
        {
          label: "",
          key: "action",
        },
      ],
    };
  },

  watch: {
    confirmed(val) {
      const tableRef = this.$refs.campaignsTable;
      tableRef.setQueryParams({ confirmed: val });
      tableRef.refreshTable();
    },
  },
  methods: {
    ...mapActions("Ministry/Communication/Campaigns", [
      "approveCampaign",
      "featureCampaign",
    ]),

    async onFeaturedClicked(id, value) {
      await this.featureCampaign({ id, value });
      this.$refs.campaignsTable.refreshTable();
      this.$toast({
        component: ToastificationContent,
        props: {
          title:
            value === true
              ? "تم تعيين الحملة كمميزة "
              : "تم تعيين الحملة كحملة عادية ",
          icon: "CheckSquareIcon",
          variant: "success",
        },
      });
    },
    async onApproveClicked(id, status) {
      await this.approveCampaign({ id, status });
      this.$refs.campaignsTable.refreshTable();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: status === "A" ? "تمت الموافقة على الحملة " : "تم رفض الحملة ",
          icon: "CheckSquareIcon",
          variant: "success",
        },
      });
    },
  },
  computed: {
    ...mapGetters("Ministry/Communication/Campaigns", ["working"]),
  },
};
</script>

<style lang="scss" scoped></style>
